import { AI_STATUS } from '@/consts';
import BaseEntity from '@/entities/BaseEntity';

export default class ImprovedCopy extends BaseEntity {
  improved_text = '';
  improved_title = '';
  improved_description = '';
  value = null;
  status = null;
  details = null;
  created_at = new Date();

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }

  get inProgress() {
    return this.status === AI_STATUS.WAITING || this.status === AI_STATUS.IN_PROGRESS;
  }

  get isDone() {
    return this.status === AI_STATUS.DONE;
  }
}
